import { TOAST_TYPES, ToastType } from "localConstants";
import React from "react";
import { ToastOptions, toast } from "react-toastify";

import { CustomToast, CustomToastProps } from "../components/UI/CustomToast/CustomToast";

export function showCustomToast(
    { title, description, buttons }: CustomToastProps,
    type: ToastType = TOAST_TYPES.SUCCESS,
    options?: ToastOptions
) {
    (toast[type] as any)(React.createElement(CustomToast, { title, description, buttons, type }), {
        ...options,
        icon: false,
    });
}
